import type { AvatarWithLineProps } from '../types';

export const Avatar = ({ avatar, name }: AvatarWithLineProps) => (
	<div className="relative">
		<div className="w-[32px] h-[32px] rounded-full shrink-0">
			<img
				src={avatar ?? '/images/user.png'}
				alt={name}
				className="w-full h-full rounded-full object-cover"
			/>
		</div>
	</div>
);
